<template>
  <div>
    <b-col>


      <div class="custom-control custom-switch d-inline-block">
        <input type="checkbox" name="check-button" class="custom-control-input" @change="autoLoadChatsFunction()"
               v-model="autoLoadChats"
               id="publishedCheckbox"/>
        <label class="custom-control-label" for="publishedCheckbox">نمایش چت های جدید</label>
      </div>

      <button class="btn btn-primary mx-3 d-inline-block px-3 rounded-pill" type="button" v-b-toggle.filters>
        فیلتر
      </button>

      <m-a :href="{name:'ChatCreate'}">

        <button class="btn btn-success  d-inline-block px-3 rounded-pill" type="button">
          چت جدید
        </button>

      </m-a>


      <b-collapse id="filters" class="p-2">
        <b-row class="my-4">
          <b-col lg="4">
            <div class="status-filter">
              <p>وضعیت چت</p>
              <select @change="chatStatusFilter" v-model="chatStatusValue" class="custom-select">
                <option value="">همه موارد</option>
                <option v-for="(item,index) in ChatStatus" :value="index">{{ item }}</option>
              </select>
            </div>

            <div class="chat_type_filter mt-3">
              <p>نوع چت</p>
              <select @change="chatTypeFilter" v-model="chatTypeValue" class="custom-select">
                <option value="">همه موارد</option>
                <option v-for="(item,index) in ChatType" :value="index">{{ item }}</option>
              </select>
            </div>

            <div class="search-filter mt-3">
              <search-filter1 @search="searchFilter"/>
            </div>


          </b-col>

          <b-col>
            <filter-category1 @updateFilter="setCategoryFilter"/>
          </b-col>
          <b-col>
            <tag-filter-1 @updateFilter="setTagsFilter"/>
          </b-col>

        </b-row>
      </b-collapse>


    </b-col>

    <table-items :items="items" :restoreState="false"/>
    <div class="row pt-3">
      <div class="mt-3 color">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Pagination from "../../components/dashboard/Pagination";
import tableItems from "../../components/dashboard/Chat/tableItems.vue";
import {ChatStatus, ChatType} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Chat'
import FilterCategory1 from "../../components/dashboard/Filters/Category/Category1/FilterCategory1.vue";
import TagFilter1 from "../../components/dashboard/Filters/Tag/TagFilter1.vue";
import ChatForm from "@/plugin/components/dashboard/Chat/ChatForm.vue";
import SearchFilter1 from "@/plugin/components/dashboard/Filters/Search/SearchFilter1.vue";

export default {
  name: "Chats",
  components: {SearchFilter1, ChatForm, tableItems, Pagination, FilterCategory1, TagFilter1},
  data() {
    return {
      autoLoadChats: false,
      printedOrders: [],
      updateList: false,
      searchWords: '',
      chatStatusValue: '',
      chatTypeValue: '',
      ChatStatus,
      ChatType,
    }
  },
  computed: {
    ...mapGetters({
      items: "Chat/getChats",
      paginationMeta: "Chat/getPagination",
      isAdmin: 'User/isAdmin'
    }),
  },
  methods: {
    async changePage(page) {
      this.autoLoadChats = false;
      await this.$store.dispatch("Chat/getChats", page)
    },
    async setPrintedOrder() {
      this.printedOrders = []

      await this.items.forEach(item => {
        if (item.status.status_id == 1) {
          this.printedOrders.push(item.id)
        }
      })

    },
    async autoLoadChatsFunction() {


      if (this.autoLoadChats) {

        this.$store.commit("Chat/setFilters", {key: "status", value: ''});
        await this.$store.dispatch("Chat/getChats");

        setTimeout(async function () {
          await this.autoLoadChatsFunction()
        }.bind(this), 5000)

      }


    },
    chatStatusFilter() {
      this.$store.commit("Chat/setFilters", {key: "status", value: this.chatStatusValue});
      this.$store.dispatch('Chat/getChats', 1)
    },
    chatTypeFilter() {
      this.$store.commit("Chat/setFilters", {key: "item_type", value: this.chatTypeValue});
      this.$store.dispatch('Chat/getChats', 1)
    },
    setCategoryFilter(data) {
      console.log('in in in ')
      let categories = data.category;

      this.$store.commit("Chat/setFilters", {key: "category", value: categories});
      this.$store.dispatch('Chat/getChats', 1)


    },
    setTagsFilter(data) {
      this.$store.commit("Chat/setFilters", {key: "tag", value: data.tags});
      this.$store.dispatch('Chat/getChats', 1)
    },
    searchFilter(data) {
      this.$store.commit("Chat/setFilters", {key: "search", value: data.searchWords});
      this.$store.dispatch('Chat/getChats', 1)
    }
  },
  async mounted() {
    await this.$store.dispatch("Chat/getChats")
  },
  destroyed() {
    this.autoLoadChats = false
    this.$store.commit("Chat/setFilters", {key: "category", value: []});
    this.$store.commit("Chat/setFilters", {key: "item_type", value: ''});
    this.$store.commit("Chat/setFilters", {key: "tag", value: []});
    this.$store.commit("Chat/setFilters", {key: "status", value: ''});
    this.$store.commit("Chat/setFilters", {key: "search", value: ''});
  }
};
</script>